import React from "react";
import styles from "./Scroll.module.scss";

const Scroll = (props) => {

  const { className, children } = props
  return <div className={`${styles.scroll} ${className ? className : ''}`}>{children}</div>;
};

export default Scroll;
